var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quicklink-menu plusmenu",staticStyle:{"display":"none"},attrs:{"id":"threadMenu"}},[_c('nested-menu',{ref:"nestedMenu",staticClass:"nested-menu",attrs:{"isroot":true,"parentexpanded":false},on:{"onclick":_vm.doClick}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f809a10","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/discuss/discuss-menu.vue
// module id = 1164
// module chunks = 0